module.exports = __webpack_public_path__ + "img/Humanisme_Tanker_i_tida3.f128b783.jpg";